<script>
  import { MDCDialog } from '@material/dialog';
  import { show_message } from '../flash';
  import { check_ws_connection, check_ws_variables } from '../websocket';
  import { t9n } from '../translate';
  import { TS } from '../../config/translation-keys';
  import { onDestroy, onMount } from 'svelte';

  export let nets_host;
  export let show;
  export let transaction_id;
  export let callback;

  let dialog;
  let websocket_error_can_not_connect = t9n(TS.WEBSOCKET_ERROR_CAN_NOT_CONNECT);

  export const open = async () => {
    let ws_is_working = check_ws_variables();

    if (ws_is_working) {
      // console.log({ws_is_working})
      await init_form();
      dialog.open();
    } else {
      show_message(websocket_error_can_not_connect, 'action');
      check_ws_connection();
    }
  };

  export const close = () => dialog.close();

  const waiting_for_nets_response = async transaction_id => {
    const close_events = ['wp:card:paid', 'wp:card:reserved'];

    const handle_finalize_message = async event => {
      try {
        await callback(transaction_id);
      } catch (e) {
        console.error(e);
      } finally {
        close();
        for (let e of close_events) {
          document.removeEventListener(e, handle_finalize_message);
        }
      }
    };

    for (let event of close_events) {
      document.addEventListener(event, handle_finalize_message);
    }
  };

  const init_form = async () => {
    dialog = new MDCDialog(document.getElementById(`payment-dialog`));

    const container = document.querySelector('#payment_dialog_content');
    const nets_url = `${nets_host}/Terminal/default.aspx?merchantId=619040&transactionId=${transaction_id}&language=en_GB`;
    const iframe = document.createElement('iframe');

    // ***same as AddCardDialog
    iframe.setAttribute('id', 'nets_form');
    if (window.screen.availWidth >= 768) {
      iframe.setAttribute('style', 'min-height: 350px; min-width: 550px');
    } else {
      iframe.setAttribute('style', 'min-height: 350px; min-width: 0');
    }
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('src', nets_url);

    container.innerHTML = '';
    container.append(iframe);
    // ***sameness ends

    await waiting_for_nets_response(transaction_id);
  };

  $: if (show && transaction_id) open();
</script>

<div id="payment-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="dialog"
      tabindex="0"
      aria-modal="true"
      aria-labelledby="payment_dialog_title"
      aria-describedby="payment-dialog-content">
      <h2
        class="mdc-dialog__title"
        style="text-align: center"
        id="payment_dialog_title">
        Pay
      </h2>
      <!-- this p tag is needed for focus trap -->
      <p style="margin: 0;" />
      <div class="mdc-dialog__content" id="payment_dialog_content" />

    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
  /* This override is for the Nets iframe to fit */
  .mdc-dialog .mdc-dialog__surface {
    max-width: 100%;
  }
</style>
